const action = {
    CHANGE_UI_CALCULATION_RUN: 'CHANGE_UI_CALCULATION_RUN',
    CHANGE_USER_NAME: 'CHANGE_USER_NAME',
    FETCH_PRODUCTS_AVAILABLE: 'FETCH_PRODUCTS_AVAILABLE',
    INITIALIZE_WEBSOCKET: 'INITIALIZE_WEBSOCKET',
}

export default action
